if (!customElements.get('longship-image-grid-slider')) {
  customElements.define(
    'longship-image-grid-slider',
    class NVImageGridSlider extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        this.swiper = new Swiper(this.querySelector('.swiper'), {
          slidesPerView: this.dataset.mobile || 1,
          loop: false,
          spaceBetween: parseInt(this.dataset.space) || 0,
          centeredSlides: false,
          observer: true,        // auto-update when DOM changes
          observeParents: true,  // watch parent elements too
          resizeObserver: true,
          breakpoints: {
            768: {
              slidesPerView: this.dataset.tablet || 2
            },
            1024: {
              slidesPerView: this.dataset.desktop || 3
            }
          }
        });
      }
    }
  );
}